import { createSelector } from "reselect";

import {
  getCurrentSale,
  getManualAdjustments,
  selectFromBusinessIdByManualAdjustmentIdLookup,
  selectManualAdjustmentIdsByLivestockSaleId,
  selectToBusinessIdByManualAdjustmentIdLookup,
} from "selectors";

export const selectManualAdjustmentIdsByTypeLookup = createSelector(
  [getManualAdjustments],
  manualAdjustments => {
    return Object.values(manualAdjustments).reduce((acc, cur) => {
      acc[cur.entityType] = {
        ...(acc[cur.entityType] || {}),
        [cur.entityId]: [...(acc[cur.entityType]?.[cur.entityId] || []), cur],
      };

      return acc;
    }, {});
  },
);

export const selectorCategorisedBusinessIdsFromCurrentSaleManualAdjustments = createSelector(
  [
    selectManualAdjustmentIdsByLivestockSaleId,
    selectFromBusinessIdByManualAdjustmentIdLookup,
    selectToBusinessIdByManualAdjustmentIdLookup,
    getCurrentSale,
  ],
  (
    manualAdjustmentIdsByLivestockSaleId,
    fromBusinessIdByManualAdjustmentIdLookup,
    toBusinessIdByManualAdjustmentIdLookup,
    currentSale,
  ) => {
    const manualAdjustmentIdsInSale =
      manualAdjustmentIdsByLivestockSaleId[(currentSale?.livestocksale_id)] ||
      [];

    return manualAdjustmentIdsInSale.reduce(
      (acc, cur) => {
        acc.from.push(fromBusinessIdByManualAdjustmentIdLookup[cur]);
        acc.to.push(toBusinessIdByManualAdjustmentIdLookup[cur]);
        return acc;
      },
      { from: [], to: [] },
    );
  },
);
